import { KEY_CODE_TO_KEY_CONVERSION } from "../gearshiftGame/constants";

export function toQwertyUsKeycapFromCode(keyCode) {
 return KEY_CODE_TO_KEY_CONVERSION[keyCode] ?? keyCode;
}

export function buildResponseDataFromKeyCode(keyCode, rawValue = null) {
 const responseData = {
  response: toQwertyUsKeycapFromCode(keyCode),
  response_event_code: keyCode,
 };

 if (rawValue !== null && rawValue !== undefined) {
  responseData.response_raw_value = rawValue;
 }

 return responseData;
}

const DEBUG_ONLY_KEYBOARD_FIELDS = new Set(["keyValueRaw", "response_raw_value"]);

export function stripDebugOnlyKeyboardFields(value) {
 if (Array.isArray(value)) {
  return value.map((item) => stripDebugOnlyKeyboardFields(item));
 }

 if (!value || typeof value !== "object") {
  return value;
 }

 return Object.fromEntries(
  Object.entries(value)
   .filter(([key]) => !DEBUG_ONLY_KEYBOARD_FIELDS.has(key))
   .map(([key, child]) => [key, stripDebugOnlyKeyboardFields(child)])
 );
}

export function normalizeKeyboardFieldsForSend(value) {
 if (Array.isArray(value)) {
  return value.map((item) => normalizeKeyboardFieldsForSend(item));
 }

 if (!value || typeof value !== "object") {
  return value;
 }

 const normalized = Object.fromEntries(
  Object.entries(value).map(([key, child]) => [key, normalizeKeyboardFieldsForSend(child)])
 );

 if (
  normalized.keyboard_mapping
  && typeof normalized.keyboard_mapping === "object"
  && !Array.isArray(normalized.keyboard_mapping)
 ) {
  const convertedMapping = Object.fromEntries(
   Object.keys(normalized.keyboard_mapping).map((eventCode) => [
    eventCode,
    toQwertyUsKeycapFromCode(eventCode),
   ])
  );
  normalized.keyboard_mapping = convertedMapping;
  normalized.keyboard_mapping_event_codes = Object.keys(convertedMapping);
 }

 if (typeof normalized.response === "string" && KEY_CODE_TO_KEY_CONVERSION[normalized.response]) {
  normalized.response_event_code = normalized.response;
  normalized.response = toQwertyUsKeycapFromCode(normalized.response);
 }

 if (typeof normalized.keyCode === "string") {
  const qwertyUsKeycap = toQwertyUsKeycapFromCode(normalized.keyCode);

  if (typeof normalized.keyValue === "string") {
   normalized.keyValue = qwertyUsKeycap;
  }

  if (typeof normalized.key === "string" && normalized.key !== normalized.keyCode) {
   normalized.key = qwertyUsKeycap;
  }
 }

 return normalized;
}